import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
import ForecastAreaChart from '../core/ForecastAreaChart';
import { Playground } from 'docz';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "forecast-area-chart-example"
    }}>{`Forecast area chart example`}</h1>
    <h2 {...{
      "id": "demo"
    }}>{`Demo`}</h2>
    <Playground __position={0} __code={'<ForecastAreaChart\n  tooltip={{\n    current: { label: \'Lançamento\', result: \'Posição\' },\n    forecast: { label: \'Projeção\', result: \'Posição\' },\n  }}\n  yComplement=\" km\"\n  forecastChartLegends={{\n    current: \'current\',\n    forecast: \'forecast\',\n    lineMark: \'divisor\',\n  }}\n  xType=\"time\"\n  grid={{ left: \'10%\' }}\n  forecastColor=\"orange\"\n  color=\"blue\"\n  lineMarkValue={2}\n  lineMarkColor=\"red\"\n  data={[\n    {\n      label: \'2019-01-01 09:20\',\n      result: 1.8,\n    },\n    {\n      label: \'2019-01-01 09:21\',\n      result: 4.5,\n    },\n    {\n      label: \'2019-03-01 09:20\',\n      result: 3,\n    },\n    {\n      label: \'2019-04-01 09:20\',\n      result: 2,\n    },\n    {\n      label: \'2019-05-01 09:20\',\n      result: 4,\n    },\n    {\n      label: \'2019-06-01 09:20\',\n      result: 4,\n    },\n    {\n      label: \'2019-05-02 09:20\',\n      result: 4,\n    },\n    {\n      label: \'2019-06-03 09:20\',\n      result: 4,\n    },\n    {\n      label: \'2019-05-01 09:20\',\n      result: 4,\n    },\n    {\n      label: \'2019-06-04 09:20\',\n      result: 4,\n    },\n    {\n      label: \'2019-05-05 09:20\',\n      result: 4,\n    },\n    {\n      label: \'2019-06-07 09:20\',\n      result: 4,\n    },\n  ]}\n/>'} __scope={{
      props,
      DefaultLayout,
      ForecastAreaChart,
      Playground,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <ForecastAreaChart tooltip={{
        current: {
          label: 'Lançamento',
          result: 'Posição'
        },
        forecast: {
          label: 'Projeção',
          result: 'Posição'
        }
      }} yComplement=" km" forecastChartLegends={{
        current: 'current',
        forecast: 'forecast',
        lineMark: 'divisor'
      }} xType="time" grid={{
        left: "10%"
      }} forecastColor="orange" color="blue" lineMarkValue={2} lineMarkColor="red" data={[{
        label: '2019-01-01 09:20',
        result: 1.8
      }, {
        label: '2019-01-01 09:21',
        result: 4.5
      }, {
        label: '2019-03-01 09:20',
        result: 3
      }, {
        label: '2019-04-01 09:20',
        result: 2
      }, {
        label: '2019-05-01 09:20',
        result: 4
      }, {
        label: '2019-06-01 09:20',
        result: 4
      }, {
        label: '2019-05-02 09:20',
        result: 4
      }, {
        label: '2019-06-03 09:20',
        result: 4
      }, {
        label: '2019-05-01 09:20',
        result: 4
      }, {
        label: '2019-06-04 09:20',
        result: 4
      }, {
        label: '2019-05-05 09:20',
        result: 4
      }, {
        label: '2019-06-07 09:20',
        result: 4
      }]} mdxType="ForecastAreaChart" />
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      